import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractEntityService } from '@app/shared/abstract/abstract-entity.service';
import { PaymentModel } from '@app/events/shared/payment.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentService extends AbstractEntityService<PaymentModel> {
  constructor(http: HttpClient) {
    super('/api/payments', http);
  }
}
